function parseRatio(ratio) {
    const [x, y] = ratio.split('x');
    return [Number(x), Number(y)];
}
export default parseRatio;
